<template>
  <Section>
    <div class="d-flex flex-column">
      <div class="d-flex align-center">
        <div class="black--text font-weight-bold">
          Total Referrals: {{ pro.referrals.length}} (Listed Below)
        </div>
      </div>
      <div v-if="isDeleted(pro)" class="pt-1 text-center">
        This Pro's account has been closed.
      </div>
      <div 
        v-else-if="userIsAdmin"
        class="d-flex flex-wrap align-center mt-2"
        style="gap: 8px 8px;"
      >
        <InNetworkButton :pro="pro" />
        <PauseButton :pro="pro" v-if="isPartner(pro)" />
        <InviteButton :pro="pro" v-if="!pro.account_claimed"/>
        <ExampleLeadDialog 
          :pro="pro" 
          v-if="isPartner(pro)" 
          @reload="$emit('reload')"
        />
      </div>
      <div 
        v-else
        class="d-flex flex-wrap align-center mt-2"
        style="gap: 8px 8px;"
      >
        <ExampleLeadDialog 
          :pro="pro" 
          v-if="isPartner(pro)" 
          @reload="$emit('reload')"
        />
      </div>
    </div>
  </Section>
</template>

<script>
  import { Section } from '@/components/pages'
  import InNetworkButton from '../components/InNetworkButton'
  import InviteButton from '../components/InviteButton'
  import PauseButton from '../components/PauseButton'
  import ExampleLeadDialog from '../components/ExampleLead'

  import { mapActions, mapGetters } from 'vuex'
  import proMixin from '../proMixin'

  export default {
    name: 'ProEnableSection',
  
    mixins: [ proMixin ],

    props: ['pro'],

    components: { Section, InNetworkButton, InviteButton, ExampleLeadDialog, PauseButton },

    computed: {
      ...mapGetters ('auth', ['userIsAdmin']),
    },

    methods: {
      ...mapActions('pros', ['updateCurrent']),
    },
  }
</script>

<style>
  .pldc .enable_switch label {
    font-size: 14px;
  }
</style>